import React from "react"
import StyledModal, { ModalProps } from "../StyledModal"
import success from "../../assets/imgs/game-details/success.png"

import Image from "next/future/image"
import { useTranslation } from "next-i18next"
import close from "../../assets/imgs/home/bg_x.png"
import useBBBNetwork from "../../hooks/useBBBNetwork"
import { formatEtherscanLink, getGameTypeString } from "../../utils/string"
import { Tooltip } from "../shared/Tooltip"
import clsx from "clsx"
import { twMerge } from "tailwind-merge"
import { Copy } from "../shared/Copy"

interface CreateSuccessModalProps extends ModalProps {
    gameDetails: any
    transactionHash: string
    pageUrl?: string
}

export const CreateSuccessModal = ({
    gameDetails,
    pageUrl,
    isOpen,
    onRequestClose,
    transactionHash
}: CreateSuccessModalProps) => {
    const { t: tCommon } = useTranslation("common")
    const { t: tGameCreate } = useTranslation("game-create")

    const { isThunderCore, isBsc, isPolygon, currentChainId } = useBBBNetwork()

    const { type } = gameDetails

    return (
        <StyledModal isOpen={isOpen} onRequestClose={onRequestClose}>
            <div
                className={"relative w-[468px] bg-[url(../assets/imgs/bg/game-create.png)] bg-[length:100%_100%] pb-10"}
            >
                <div className="pt-[9px] text-right">
                    <img
                        src={close.src}
                        onClick={onRequestClose}
                        className="float-right mr-[12px] w-[30px] hover:opacity-80"
                    />
                </div>
                <div className={"mt-7 text-center text-2xl1 font-bold text-neutral-1-500"}>
                    {tGameCreate("success.label")}
                </div>
                <div className={"b-flex-center mt-5"}>
                    <Image src={success} alt={"Success"} />
                </div>
                <div
                    className={"mt-4 text-center font-secondary text-base font-normal leading-5 text-neutral-1-500"}
                    dangerouslySetInnerHTML={{
                        __html: tGameCreate("success.description", {
                            type: tGameCreate(`game.${getGameTypeString(type)}`)
                        })
                    }}
                ></div>
                {pageUrl && (
                    <div className={"b-flex-center mx-auto mt-[11px] h-[44px] w-[365px] rounded-[5px] bg-[#E4E6EB]"}>
                        <Tooltip
                            message={"You can use the URL link as a challenge invitation"}
                            messageClassName={"w-[140px]"}
                            iconClassName={"fill-neutral-1-600"}
                        />
                        <span
                            className={
                                "mx-2 max-w-[287px] overflow-hidden text-ellipsis whitespace-nowrap font-secondary text-base font-normal leading-5 text-[#0FAFE1]"
                            }
                        >
                            {pageUrl}
                        </span>
                        <Copy text={pageUrl} />
                    </div>
                )}
                <div className={twMerge(clsx("b-flex-center mt-9 text-center", pageUrl && "mt-6"))}>
                    <a
                        href={formatEtherscanLink("Transaction", [currentChainId, transactionHash])}
                        target={"_blank"}
                        rel={"noreferrer"}
                    >
                        <button
                            className="b-flex-center h-[43px] w-[258px] rounded-[3px] bg-accent-1 font-bold text-neutral-1 hover:text-neutral-1-100"
                            type={"button"}
                        >
                            {isBsc && tCommon("button.viewBsc")}
                            {isThunderCore && tCommon("button.viewThunderCore")}
                            {isPolygon && tCommon("button.viewPolygon")}
                            {isBsc && tCommon("button.viewArbitrum")}
                        </button>
                    </a>
                </div>
            </div>
        </StyledModal>
    )
}
